<template>
  <Autocomplete
    ref="autocomplete"
    class="waypoint-input-container"
    :class="{ 'is-centent': searchValue }"
    v-model="searchValue"
    :fetch-suggestions="fetchSuggestions"
    :debounce="0"
    :disabled="disabled"
    :hideLoading="resultList.length > 0"
    :placeholder="placeholder"
    :select-when-unmatched="true"
    :highlight-first-item="true"
    @select="handleSelect"
    @onDropdownVisibleChange2="handleVisibleChange"
    @clear="handleClear"
  >
    <svg-icon slot="suffix" name="ic-guide-close" class="close-icon" @click.native="handleClear" />
    <template slot-scope="{ item }">
      <Point :info="item" />
    </template>
    <div slot="empty" class="waypoint-input-popper-empty-container">No Matches Found</div>
  </Autocomplete>
</template>
<script>
import { mapActions } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import debounce from 'lodash/debounce'
import { tripPlanPointInfo } from '@/store/modules/trip-plan'
import Autocomplete from '../autocomplete'
import Point from './point'
export default {
  components: {
    Autocomplete,
    Point
  },
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ''
    },
    index: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    info: {
      handler(val) {
        this.searchValue = val.value
      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      resultList: [],
      searchValue: ''
    }
  },
  computed: {
  },
  methods: {
    ...mapActions({
      querySearchAsync: 'search/querySearch',
      addSearchReturnAsync: 'search/addSearchReturn'
    }),
    fetchSuggestions(queryString, cb) {
      if (!queryString) {
        this.resultList = []
        cb([])
        return null
      } else if (this.resultList.length) {
        cb(this.resultList)
      }
      this.handleSearch(queryString, cb)
    },
    handleSearch: debounce(function (queryString, cb) {
      this.querySearchAsync({ value: queryString, isShowHistoricalData: false }).then(res => {
        if (queryString === this.searchValue) {
          this.resultList = this.formatList(res)
          cb(this.resultList)
        }
      })
    }, 300),
    formatList(list) {
      return list.map(item => {
        let reg = new RegExp(this.searchValue, 'i')
        return {
          ...item,
          unifiedTitle: item.value.replace(reg, $1 => `<b>${$1}</b>`),
          unifiedAddress: item.address.replace(reg, $1 => `<b>${$1}</b>`)
        }
      })
    },
    handleSelect(point) {
      if (!point.latitude || !point.longitude) {
        return null
      }
      let info = Object.assign({}, this.info, {
        value: point.title,
        latitude: point.latitude,
        longitude: point.longitude,
        pointInfo: point,
        pointType: point.pointType,
        pointId: point.pointId,
        requestCompleted: false
      })
      if (point.pointType === 'poi') {
        info = Object.assign(info, {
          requestCompleted: true,
          tid: point.tid,
          sid: point.sid,
          poiId: point.ident,
          pointId: point.ident
        })
      } else if (point.pointType === 'facility') {
        info.facilityId = point.facilityId
      }
      this.$emit('change', { info: info, index: this.index })
      this.addSearchReturnAsync(point)
      this.$nextTick(() => {
        this.$refs.autocomplete.close()
      })
    },
    handleVisibleChange({ status, activated }) {
      if (!status && !activated) {
        this.searchValue = this.info.value
      }
    },
    handleClear() {
      this.$emit('change', {
        info: {
          ...cloneDeep(tripPlanPointInfo),
          stopPointType: this.info.stopPointType,
          departureTime: this.info.departureTime
        },
        index: this.index
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.waypoint-input-container {
  width: 100%;
  .close-icon {
    flex-shrink: 0;
    font-size: 17px;
    cursor: pointer;
  }
  ::v-deep {
    .el-input__suffix {
      display: none;
    }
    .el-input .el-input__inner {
      padding: 0 30px 0 12px !important;
      background: rgba(255, 255, 255, 0.5) !important;
    }
  }
  &.is-centent {
    ::v-deep {
      .el-input__inner:hover + .el-input__suffix {
        display: flex;
      }
      .el-input__inner:focus + .el-input__suffix {
        display: flex;
      }
      .el-input__suffix:hover {
        display: flex;
      }
    }
  }
}
</style>
<style lang="scss">
.waypoint-input-popper-empty-container {
  height: 36px;
  display: flex;
  align-items: center;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: #B2B6C0;
}
</style>
